





























import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import CreateOrganization from "./createOrganization.vue";
import EditOrganization from "./editOrganization.vue";
import checkAuth from "@/lib/Common/checkauth";
import "@/assets/css/table.css";

class PageCityRequest extends PageRequest {
  keyword: string = "";
}

@Component({
  components: { CreateOrganization, EditOrganization },
})
export default class organization extends AbpBase {
  //检测按钮权限
  checkButtonAuth(tag: string) {
    return checkAuth.CheckButton(tag);
  }

  edit() {
    this.editModalShow = true;
  }

  pagerequest: PageCityRequest = new PageCityRequest();
  creationTime: Date[] = [];
  createModalShow: boolean = false;
  editModalShow: boolean = false;
  treedata: [] = [];
  itemId: string = "0";
  get list() {
    return this.$store.state.organization.list;
  }
  get loading() {
    return this.$store.state.organization.loading;
  }
  create() {
    this.createModalShow = true;
  }
  pageChange(page: number) {
    this.$store.commit("organization/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("organization/setPageSize", pagesize);
    this.getpage();
  }
  getItemId() {
    this.$store.commit("organization/setCurrentPage", 1);
    this.getpage();
  }
  getSearch() {
    this.$store.commit("organization/setCurrentPage", 1);
    this.getpage();
  }
  async getpage() {
    await this.$store.dispatch({
      type: "organization/getAll",
      data: this.pagerequest,
    });
  }
  get pageSize() {
    return this.$store.state.organization.pageSize;
  }
  get totalCount() {
    return this.$store.state.organization.totalCount;
  }
  get currentPage() {
    return this.$store.state.organization.currentPage;
  }
  columns = [
    {
      type: "index",
      width: 80,
      align: "left",
      fixed: "left",
      title: this.L("IndexNo"),
    },
    {
      title: this.L("Name"),
      key: "displayName",
      width: 240,
      fixed: "left",
      tree: true,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: { title: params.row.displayName },
            },
            params.row.displayName
          ),
        ]);
      },
    },
    {
      title: this.L("Encode"),
      key: "encode",
      width: 130,
    },
    {
      title: this.L("Category"),
      key: "itemDetailId",
      width: 180,
      render: (h: any, params: any) => {
        let id = params.row.itemDetailId;
        let ite = JSON.parse(localStorage.getItem("itemdetail"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("span", info.length > 0 ? info[0].name : this.L("Unknown"));
      },
    },
    {
      title: this.L("IsStatic"),
      key: "isStatic",
      width: 130,
      render: (h: any, params: any) => {
        return h("span", params.row.isStatic ? this.L("Yes") : this.L("No"));
      },
    },
    {
      title: this.L("IsEnable"),
      width: 130,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.isEnable == 1 ? this.L("Actived") : this.L("NoActive")
        );
      },
    },
    {
      title: this.L("Description"),
      key: "description",
    },
    {
      title: this.L("Id"),
      key: "id",
      width: 130,
    },
    {
      title: this.L("Actions"),
      key: "Actions",
      width: 150,
      render: (h: any, params: any) => {
        let del = this.checkButtonAuth('organizationEdit');
        let edit = this.checkButtonAuth('organizationDel');
        return h("div", [
          edit ? h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                  this.$store.commit("organization/edit", params.row);
                  this.edit();
                },
              },
            },
            this.L("Edit")
          ) : '',
          del ? h(
            "Button",
            {
              props: {
                type: "error",
                size: "small",
              },
              on: {
                click: async () => {
                  if (params.row.isStatic) {
                    this.$Modal.info({
                      title: this.L("Tips"),
                      content: this.L("StaticOrganizations"),
                    });
                    return;
                  }
                  this.$Modal.confirm({
                    title: this.L("Tips"),
                    content: this.L("DeleteConfirm"),
                    okText: this.L("Yes"),
                    cancelText: this.L("No"),
                    onOk: async () => {
                      await this.$store.dispatch({
                        type: "organization/delete",
                        data: params.row,
                      });
                      await this.getpage();
                    },
                  });
                },
              },
            },
            this.L("Delete")
          ) : '',
        ]);
      },
    },
  ];
  async created() {
    this.getpage();
    //this.itemtree();
  }
}
